import Base from "./Base.js";

export default class SettingsMagazineAPI extends Base {
    getMagazineComplaints(params) {
        return this.apiClient.get(`complaints-handling-history`, params);
    }
}
